<nav class="sidebar-nav" [class.nav--collapsed]="isCollapsed">
    <div class="nav-section">
        <div
            class="nav-item"
            [routerLink]="'/v2/painel'"
            routerLinkActive="active"
            (click)="onNavClick()"
            [matTooltip]="tooltipWhenCollapsed('menu.nav.home')"
            matTooltipPosition="right"
        >
            <mat-icon class="nav-icon">home</mat-icon>
            <span class="nav-label">{{ 'menu.nav.home' | transloco }}</span>
        </div>

        <div
            class="nav-item expandable nav-item--desktop-expanded-only"
            [class.expanded]="expandedSections.dashboard"
            (click)="toggleSection('dashboard')"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('dashboard')">dashboard</mat-icon>
            <span class="nav-label">{{ 'menu.nav.analytics' | transloco }}</span>
            <mat-icon class="expand-icon" [class.rotated]="expandedSections.dashboard">expand_more</mat-icon>
        </div>
        <div
            class="nav-item nav-item--desktop-collapsed-only"
            (click)="expandirMenu('dashboard')"
            [matTooltip]="'menu.nav.dashboard' | transloco"
            matTooltipPosition="right"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('dashboard')">dashboard</mat-icon>
        </div>
        <div class="submenu" [class.show]="expandedSections.dashboard">
            <div
                class="submenu-item"
                [class.active]="isFinancialDashboardActive()"
                (click)="onNavClick(ForbiddenLayout.DASHBOARD)"
            >
                <mat-icon class="submenu-icon">bar_chart</mat-icon>
                <span>{{ 'menu.nav.financialDashboard' | transloco }}</span>
            </div>
            <div
                class="submenu-item"
                [routerLink]="'/v2/integrations/vturb/analytics'"
                queryParamsHandling="preserve"
                routerLinkActive="active"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">videocam</mat-icon>
                <span>{{ 'menu.nav.vturbAnalytics' | transloco }}</span>
            </div>
        </div>

        @if (showManagementSection()) {
            <div
                class="nav-item expandable nav-item--desktop-expanded-only"
                [class.expanded]="expandedSections.management"
                (click)="toggleSection('management')"
            >
                <mat-icon class="nav-icon" [class.selected]="isSectionActive('management')">bar_chart</mat-icon>
                <span class="nav-label">{{ 'menu.nav.management' | transloco }}</span>
                <mat-icon class="expand-icon" [class.rotated]="expandedSections.management">expand_more</mat-icon>
            </div>
            <div class="submenu" [class.show]="expandedSections.management">
                @for (item of managementNavItems; track item.redeAds) {
                    @if (!isManagementNetworkAvailable(item)) {
                        <div
                            class="submenu-item submenu-item--unavailable"
                            role="button"
                            tabindex="0"
                            [matTooltip]="'shared.redeAdsInativaTooltip' | transloco"
                            matTooltipPosition="right"
                            (click)="$event.preventDefault(); $event.stopPropagation()"
                            (keydown.enter)="$event.preventDefault()"
                            (keydown.space)="$event.preventDefault()"
                        >
                            <span class="submenu-icon submenu-icon--rede-ads" aria-hidden="true">
                                <img [src]="item.iconSrc" alt="" loading="lazy" />
                            </span>
                            <span>{{ item.labelKey | transloco }}</span>
                            <mat-icon class="submenu-item__lock material-icons-outlined" aria-hidden="true">
                                lock
                            </mat-icon>
                        </div>
                    } @else if (isManagementNetworkComingSoon(item)) {
                        <div
                            class="submenu-item"
                            role="button"
                            tabindex="0"
                            (click)="onManagementNetworkClick(item)"
                            (keydown.enter)="onManagementNetworkClick(item)"
                            (keydown.space)="$event.preventDefault(); onManagementNetworkClick(item)"
                        >
                            <span class="submenu-icon submenu-icon--rede-ads" aria-hidden="true">
                                <img [src]="item.iconSrc" alt="" loading="lazy" />
                            </span>
                            <span>{{ item.labelKey | transloco }}</span>
                        </div>
                    } @else {
                        <div
                            #managementNetworkLink
                            class="submenu-item"
                            role="link"
                            tabindex="0"
                            [routerLink]="item.route"
                            routerLinkActive="active"
                            (click)="onNavClick()"
                            (keydown.enter)="managementNetworkLink.click()"
                            (keydown.space)="$event.preventDefault(); managementNetworkLink.click()"
                        >
                            <span class="submenu-icon submenu-icon--rede-ads" aria-hidden="true">
                                <img [src]="item.iconSrc" alt="" loading="lazy" />
                            </span>
                            <span>{{ item.labelKey | transloco }}</span>
                        </div>
                    }
                }

                @if (!isCampaignCreatorAvailable()) {
                    <div
                        class="submenu-item submenu-item--unavailable"
                        role="button"
                        tabindex="0"
                        [matTooltip]="'shared.redeAdsInativaTooltip' | transloco"
                        matTooltipPosition="right"
                        (click)="$event.preventDefault(); $event.stopPropagation()"
                        (keydown.enter)="$event.preventDefault()"
                        (keydown.space)="$event.preventDefault()"
                    >
                        <mat-icon class="submenu-icon">smart_toy</mat-icon>
                        <span>{{ 'menu.nav.campaignCreator' | transloco }}</span>
                        <mat-icon class="submenu-item__lock material-icons-outlined" aria-hidden="true">
                            lock
                        </mat-icon>
                    </div>
                } @else {
                    <div
                        class="submenu-item"
                        role="button"
                        tabindex="0"
                        [class.active]="isCampaignCreatorActive()"
                        (click)="onNavClick(ForbiddenLayout.CAMPAIGN_CREATOR)"
                        (keydown.enter)="onNavClick(ForbiddenLayout.CAMPAIGN_CREATOR)"
                        (keydown.space)="$event.preventDefault(); onNavClick(ForbiddenLayout.CAMPAIGN_CREATOR)"
                    >
                        <mat-icon class="submenu-icon">smart_toy</mat-icon>
                        <span>{{ 'menu.nav.campaignCreator' | transloco }}</span>
                    </div>
                }
            </div>
        }

        <div
            class="nav-item"
            [routerLink]="'/v2/projetos'"
            routerLinkActive="active"
            (click)="onNavClick()"
            [matTooltip]="tooltipWhenCollapsed('menu.nav.projects')"
            matTooltipPosition="right"
        >
            <mat-icon class="nav-icon">assignment</mat-icon>
            <span class="nav-label">{{ 'menu.nav.projects' | transloco }}</span>
        </div>

        @if (canSeeRatoeira) {
            <div
                class="nav-item"
                [routerLink]="'/v2/ratoeiras'"
                routerLinkActive="active"
                (click)="onNavClick()"
                [matTooltip]="tooltipWhenCollapsed('menu.nav.mousetraps')"
                matTooltipPosition="right"
            >
                <mat-icon class="nav-icon">mouse</mat-icon>
                <span class="nav-label">{{ 'menu.nav.mousetraps' | transloco }}</span>
            </div>
        }

        @if (canShowTagRatoeiraMenu()) {
            <div
                class="nav-item"
                data-cy="sidebar-nav-tag-ratoeira"
                [class.active]="isTagRatoeiraActive()"
                role="button"
                tabindex="0"
                (click)="onNavClick(ForbiddenLayout.TAG_RATOEIRA)"
                (keydown.enter)="onNavClick(ForbiddenLayout.TAG_RATOEIRA)"
                (keydown.space)="$event.preventDefault(); onNavClick(ForbiddenLayout.TAG_RATOEIRA)"
                [matTooltip]="tooltipWhenCollapsed('menu.nav.tagRatoeira')"
                matTooltipPosition="right"
            >
                <mat-icon class="nav-icon">label</mat-icon>
                <span class="nav-label">{{ 'menu.nav.tagRatoeira' | transloco }}</span>
            </div>
        }

        @if (canShowWhatsappMenu()) {
            <div
                class="nav-item"
                [routerLink]="'/v2/whatsapp'"
                routerLinkActive="active"
                (click)="onNavClick()"
                [matTooltip]="tooltipWhenCollapsed('menu.nav.whatsapp')"
                matTooltipPosition="right"
            >
                <mat-icon class="nav-icon">chat</mat-icon>
                <span class="nav-label">{{ 'menu.nav.whatsapp' | transloco }}</span>
            </div>
        }

        <div
            class="nav-item expandable nav-item--desktop-expanded-only"
            [class.expanded]="expandedSections.notificacoes"
            (click)="toggleSection('notificacoes')"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('notificacoes')">notifications</mat-icon>
            <span class="nav-label">{{ 'menu.nav.notifications' | transloco }}</span>
            <mat-icon class="expand-icon" [class.rotated]="expandedSections.notificacoes">expand_more</mat-icon>
        </div>
        <div
            class="nav-item nav-item--desktop-collapsed-only"
            (click)="expandirMenu('notificacoes')"
            [matTooltip]="'menu.nav.notifications' | transloco"
            matTooltipPosition="right"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('notificacoes')">notifications</mat-icon>
        </div>
        <div class="submenu" [class.show]="expandedSections.notificacoes">
            <div
                class="submenu-item"
                [routerLink]="'/v2/notificacoes/link-notificacao'"
                routerLinkActive="active"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">link</mat-icon>
                <span>{{ 'menu.nav.notificationLink' | transloco }}</span>
            </div>
            <div
                class="submenu-item"
                [routerLink]="'/v2/notificacoes/vendas/integracao'"
                [class.active]="isSectionActive('lista-notificacoes')"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">attach_money</mat-icon>
                <span>{{ 'menu.nav.notificationList' | transloco }}</span>
            </div>
            @if (isStaffSession) {
                <div
                    class="submenu-item"
                    [routerLink]="'/v2/notificacoes/logs'"
                    routerLinkActive="active"
                    (click)="onNavClick()"
                >
                    <mat-icon class="submenu-icon">receipt_long</mat-icon>
                    <span>{{ 'menu.nav.notificationLogs' | transloco }}</span>
                </div>
            }
        </div>

        <div
            class="nav-item expandable nav-item--desktop-expanded-only"
            [class.expanded]="expandedSections.checkout"
            [class.selected]="isSectionActive('checkout')"
            (click)="toggleSection('checkout')"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('checkout')">shopping_cart</mat-icon>
            <span class="nav-label" [class.selected]="isSectionActive('checkout')">{{
                'menu.nav.checkout' | transloco
            }}</span>
            <mat-icon class="expand-icon" [class.rotated]="expandedSections.checkout">expand_more</mat-icon>
        </div>
        <div
            class="nav-item nav-item--desktop-collapsed-only"
            (click)="expandirMenu('checkout')"
            [matTooltip]="'menu.nav.checkout' | transloco"
            matTooltipPosition="right"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('checkout')">shopping_cart</mat-icon>
        </div>
        <div class="submenu" [class.show]="expandedSections.checkout">
            <div
                class="submenu-item"
                [routerLink]="'/v2/checkout/link-checkout'"
                routerLinkActive="active"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">link</mat-icon>
                <span>{{ 'menu.nav.checkoutLink' | transloco }}</span>
            </div>
            <div
                class="submenu-item"
                [routerLink]="'/v2/checkout/lista-checkouts'"
                routerLinkActive="active"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">shopping_bag</mat-icon>
                <span>{{ 'menu.nav.checkoutList' | transloco }}</span>
            </div>
            @if (isStaffSession) {
                <div
                    class="submenu-item"
                    [routerLink]="'/v2/checkout/logs'"
                    routerLinkActive="active"
                    (click)="onNavClick()"
                >
                    <mat-icon class="submenu-icon">receipt_long</mat-icon>
                    <span>{{ 'menu.nav.checkoutLogs' | transloco }}</span>
                </div>
            }
        </div>

        <div
            class="nav-item expandable nav-item--desktop-expanded-only"
            [class.expanded]="expandedSections.integracoes"
            [class.selected]="isSectionActive('integracoes')"
            (click)="toggleSection('integracoes')"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('integracoes')">webhook</mat-icon>
            <span class="nav-label" [class.selected]="isSectionActive('integracoes')">{{
                'menu.nav.integrations' | transloco
            }}</span>
            <mat-icon class="expand-icon" [class.rotated]="expandedSections.integracoes">expand_more</mat-icon>
        </div>
        <div
            class="nav-item nav-item--desktop-collapsed-only"
            (click)="expandirMenu('integracoes')"
            [matTooltip]="'menu.nav.integrations' | transloco"
            matTooltipPosition="right"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('integracoes')">webhook</mat-icon>
        </div>
        <div class="submenu" [class.show]="expandedSections.integracoes">
            <div
                class="submenu-item"
                [routerLink]="'/v2/integrations/account-center'"
                routerLinkActive="active"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">account_circle</mat-icon>
                <span>{{ 'menu.nav.accountCenterNew' | transloco }}</span>
            </div>
            <div
                class="submenu-item"
                [routerLink]="'/v2/integrations/vturb'"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="active"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">videocam</mat-icon>
                <span>{{ 'menu.nav.vturbIntegration' | transloco }}</span>
            </div>
            @if (canShowFontesTrafego()) {
                <div
                    class="submenu-item"
                    [routerLink]="'/v2/integrations/fontes-trafego'"
                    routerLinkActive="active"
                    (click)="onNavClick()"
                >
                    <mat-icon class="submenu-icon">alt_route</mat-icon>
                    <span>{{ 'menu.nav.fontesTrafego' | transloco }}</span>
                </div>
            }
            <div
                class="submenu-item"
                [routerLink]="'/v2/integracoes/apikey'"
                routerLinkActive="active"
                (click)="onNavClick()"
            >
                <mat-icon class="submenu-icon">key</mat-icon>
                <span>{{ 'menu.nav.apiKeys' | transloco }}</span>
            </div>
        </div>

        <div
            class="nav-item expandable nav-item--desktop-expanded-only"
            [class.expanded]="expandedSections.avancado"
            [class.selected]="isSectionActive('avancado')"
            (click)="toggleSection('avancado')"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('avancado')">tune</mat-icon>
            <span class="nav-label" [class.selected]="isSectionActive('avancado')">{{
                'menu.nav.advanced' | transloco
            }}</span>
            <mat-icon class="expand-icon" [class.rotated]="expandedSections.avancado">expand_more</mat-icon>
        </div>
        <div
            class="nav-item nav-item--desktop-collapsed-only"
            (click)="expandirMenu('avancado')"
            [matTooltip]="'menu.nav.advanced' | transloco"
            matTooltipPosition="right"
        >
            <mat-icon class="nav-icon" [class.selected]="isSectionActive('avancado')">tune</mat-icon>
        </div>
        <div class="submenu" [class.show]="expandedSections.avancado">
            <div class="submenu-item" [class.active]="isUrlProdutorActive()" (click)="acessarUrlProdutor()">
                <mat-icon class="submenu-icon">link</mat-icon>
                <span>{{ 'menu.nav.producerUrl' | transloco }}</span>
            </div>
            @if (authService.canSeeRatoeira() && !isMinimumPlan) {
                <div
                    class="submenu-item"
                    [routerLink]="'/v2/relatorios'"
                    routerLinkActive="active"
                    (click)="onNavClick()"
                >
                    <mat-icon class="submenu-icon">description</mat-icon>
                    <span>{{ 'menu.nav.reports' | transloco }}</span>
                </div>
            }
            @if (authService.canSeeRatoeira()) {
                <div
                    class="submenu-item"
                    [routerLink]="'/v2/dominios'"
                    routerLinkActive="active"
                    (click)="onNavClick()"
                >
                    <mat-icon class="submenu-icon">language</mat-icon>
                    <span>{{ 'menu.nav.ownDomains' | transloco }}</span>
                </div>
            }
            @if (!isMinimumPlan) {
                <div class="submenu-item" [routerLink]="'/v2/taxes'" routerLinkActive="active" (click)="onNavClick()">
                    <mat-icon class="submenu-icon">bar_chart</mat-icon>
                    <span>{{ 'menu.nav.taxes' | transloco }}</span>
                </div>
                <div class="submenu-item" [routerLink]="'/v2/fees'" routerLinkActive="active" (click)="onNavClick()">
                    <mat-icon class="submenu-icon">campaign</mat-icon>
                    <span>{{ 'menu.nav.fees' | transloco }}</span>
                </div>
                <div
                    class="submenu-item"
                    [routerLink]="'/v2/products'"
                    routerLinkActive="active"
                    (click)="onNavClick()"
                >
                    <mat-icon class="submenu-icon">table_chart</mat-icon>
                    <span>{{ 'menu.nav.products' | transloco }}</span>
                </div>
            }
        </div>
    </div>
</nav>
